
import {useLocation, useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import {DataTableColumn} from "../../../../components/common/datatable/DataTableTypes";
import {useSearchScraperModulesQuery,useLazyExportScraperModulesDataQuery} from "../scraperModuleApi";
import {useEffect, useState} from "react";
import {createClickableLink} from "../../../../components/common/datatable/DataTableUtils";
import {SearchInputWrapper} from "../../../../components/common/datatable/filter/SearchInputWrapper";
import {SearchSelectWithEnum} from "../../../../components/common/datatable/filter/SearchSelectWrapper";
import Breadcrumb from "../../../../components/common/Breadcrumbs";
import {DataTable} from "../../../../components/common/datatable/DataTable";
import {useGetEnumsQuery} from "../../../../app/globalApi";
import {getEnumDisplayNameByConstant} from "../../../../helpers/utils/EnumUtils";
import IconButton from "../../../../components/common/form/IconButton";
import { FaPlus } from "react-icons/fa";
import {useFindUserSettingsByGroupNameQuery} from "../../../../components/common/userSetting/userSettingsApi";
const ScraperModule = () => {

    const { data: userSetting } = useFindUserSettingsByGroupNameQuery("Scraper Module");
    const {data: enums} = useGetEnumsQuery("");
    const [triggerExportScraperModulesDataQuery] = useLazyExportScraperModulesDataQuery();
    const navigate=useNavigate();
    useEffect(() => {
        document.title = 'Scrapers Modules';
    }, []);

    const [crumbs] = useState([
        {content: "Home", url: "/home"},
        {content: "Scraper Modules", url: ""}]
    )

    const [moduleKey, setModuleKey] = useState([]);
    const [supportingModule, setSupportingModule] = useState([]);

    let chosenSelectorFilter = [
        {
            chosenSelectorAccessor: "moduleKeys",
            value: moduleKey,
            defaultValue:[],
            setToDefault: setModuleKey
        },
        {
            chosenSelectorAccessor: "supportingModules",
            value: supportingModule,
            defaultValue:[],
            setToDefault: setSupportingModule
        },
    ];



    const columns: DataTableColumn[] = [
            {
                label: "Name", accessor: "name",
                cell: (props: any) => {
                        let path = "/scrapers-modules/" + props.row.original.id;
                        return createClickableLink(path, props.row.original.name, userSetting, false, "", ["LOGIC-R"]);
                },
                filterOptions: [{
                    filterComponent: <SearchInputWrapper type={"text"} placeholder={"Enter Name..."} name={"name"}
                                                         accessor={"name"}/>,
                    overrideFilterAccessor: "name"
                }],
            },
            {
                label: "Module Key", accessor: "moduleKey",
            },
            {
                label: "URL", accessor: "url"
            },
            {
                label: "Supporting Module(s)", accessor: "supportingModules", canSort:false,
                cell: (props: any) => {
                    let content = props.row.original.supportingModules.map((curModule: any) => {
                        return curModule.name;
                    }).join(", ");
                    return <><span className="text_wrap_msa_grid" title={content}>{content}</span></>
                },
            
            },
            {
                label: "Proxy Type", accessor: "proxyService",
                cell: (props:any) => {
                    return <>
                        <span>{getEnumDisplayNameByConstant(enums?.["ProxyService"], props.value)}</span>
                    </>
                },
                filterOptions: [{
                    filterComponent: SearchSelectWithEnum(enums?.["ProxyService"], "Select Proxy Type...", false, "proxyService"),
                }],
            }
            ]

    return (
        <div className="user-container px-4 py-2">
        <div className="flex justify-between mb-2.5">
            <Breadcrumb crumbs={crumbs}/>
        </div>

                            <DataTable
                                columns={columns}
                                actions={{
                                    fetchAction: useSearchScraperModulesQuery,
                                    exportAction: triggerExportScraperModulesDataQuery
                                }}
                                buttonOptions={{
                                    addButton:
                                        {
                                            button: <IconButton
                                                icon={<FaPlus/>}
                                                hasBackground={true}
                                                onClick={() => {
                                                    navigate("/scrapers-modules/create")
                                                }}
                                                title={"Add Scraper Module"}
                                            />,
                                            permissions: ["LOGIC-C"]
                                        },
                
                                }}
                                userSettingGroup={"Scraper Module"}
                                defaultSortOptions={{
                                    accessor: "name",
                                    direction: "asc"
                                }}
                                basePermission={"SCRMOD"}
                            />
                        </div>
    );
}
export default ScraperModule;